<!-- breadcrumb -->
<div class="breadcrumb-header justify-content-between">
  <div class="my-auto">
    <div class="d-flex">
      <h4 class="content-title mb-0 my-auto">Tables</h4>
      <span class="text-muted mt-1 tx-13 ms-2 mb-0">/ Edit Tables</span>
    </div>
  </div>
  <div class="d-flex my-xl-auto right-content">
    <div class="pe-1 mb-xl-0">
      <button type="button" class="btn btn-info btn-icon me-2 btn-b">
        <i class="mdi mdi-filter-variant"></i>
      </button>
    </div>
    <div class="pe-1 mb-xl-0">
      <button type="button" class="btn btn-danger btn-icon me-2">
        <i class="mdi mdi-star"></i>
      </button>
    </div>
    <div class="pe-1 mb-xl-0">
      <button type="button" class="btn btn-warning btn-icon me-2">
        <i class="mdi mdi-refresh"></i>
      </button>
    </div>
    <div class="mb-xl-0">
      <div ngbDropdown class="btn-group">
        <button type="button" class="btn btn-primary">14 Aug 2019</button>
        <button type="button" ngbDropdownToggle class="btn btn-primary dropdown-toggle-split" id="dropdownMenuDate"
          data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <span class="sr-only">Toggle Dropdown</span>
        </button>
        <div ngbDropdownMenu class="dropdown-menu-right" aria-labelledby="dropdownMenuDate"
          data-x-placement="bottom-end">
          <a ngbDropdownItem href="javascript:;">2015</a>
          <a ngbDropdownItem href="javascript:;">2016</a>
          <a ngbDropdownItem href="javascript:;">2017</a>
          <a ngbDropdownItem href="javascript:;">2018</a>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- breadcrumb -->

<!-- Row -->
<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-header">
        <h3 class="card-title">Basic Edit Table</h3>
      </div>
      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-bordered border text-nowrap mb-0" id="basic-edit">
            <thead>
              <tr>
                <th>First name</th>
                <th>Last name</th>
                <th>Position</th>
                <th>Start date</th>
                <th>Salary</th>
                <th>E-mail</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              @for (item of user; track item) {
                <tr>
                  <td>
                    @if (item.editable) {
                      <div>
                        <input type="text" [(ngModel)]="item.firstName" class="form-control" />
                      </div>
                    }
                    @if (!item.editable) {
                      <div>
                        {{ item.firstName }}
                      </div>
                    }
                  </td>
                  <td>
                    @if (item.editable) {
                      <div>
                        <input type="text" [(ngModel)]="item.lastName" class="form-control" />
                      </div>
                    }
                    @if (!item.editable) {
                      <div>
                        {{ item.lastName }}
                      </div>
                    }
                  </td>
                  <td>
                    @if (item.editable) {
                      <div>
                        <input type="text" [(ngModel)]="item.position" class="form-control" />
                      </div>
                    }
                    @if (!item.editable) {
                      <div>
                        {{ item.position }}
                      </div>
                    }
                  </td>
                  <td>
                    @if (item.editable) {
                      <div>
                        <input type="text" [(ngModel)]="item.startData" class="form-control" />
                      </div>
                    }
                    @if (!item.editable) {
                      <div>
                        {{ item.startData }}
                      </div>
                    }
                  </td>
                  <td>
                    @if (item.editable) {
                      <div>
                        <input type="text" [(ngModel)]="item.salary" class="form-control" />
                      </div>
                    }
                    @if (!item.editable) {
                      <div>
                        {{ item.salary }}
                      </div>
                    }
                  </td>
                  <td>
                    @if (item.editable) {
                      <div>
                        <input type="text" [(ngModel)]="item.email" class="form-control" />
                      </div>
                    }
                    @if (!item.editable) {
                      <div>
                        {{ item.email }}
                      </div>
                    }
                  </td>
                  <td>
                    @if (item.editable) {
                      <button (click)="item.editable = false; update(item)" type="button"
                        class="btn btn-sm btn-primary">
                        <span class="fe fe-check-circle"> </span>
                      </button>
                    }
                    @if (!item.editable) {
                      <button id="bEdit" type="button" class="btn btn-sm btn-primary"
                        (click)="edit(item)">
                        <span class="fe fe-edit"> </span>
                      </button>
                    }
                    @if (item.editable) {
                      <button (click)="item.editable = false" type="button"
                        class="btn mx-2 btn-sm btn-danger">
                        <span class="fe fe-x-circle"> </span>
                      </button>
                    }
                    @if (!item.editable) {
                      <button id="bDel" type="button" class="btn mx-3 btn-sm btn-danger"
                        (click)="trash(item.id)">
                        <span class="fe fe-trash-2"> </span>
                      </button>
                    }
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- End Row -->

<!-- Row -->
<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-header">
        <h3 class="card-title">Add New Row with Edit Table</h3>
      </div>
      <div class="card-body">
        @for (item of addRow; track item) {
          <div class="table-responsive">
            <button id="table2-new-row-button" class="btn btn-primary mb-4" (click)="item.editable = true" >
              Add New Row
            </button>
            @if (item.editable) {
              <table class="table table-bordered border text-nowrap mb-0 my-4" id="new-edit">
                <thead>
                  <tr>
                    <th>First name</th>
                    <th>Last name</th>
                    <th>Position</th>
                    <th>Start date</th>
                    <th>Salary</th>
                    <th>E-mail</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td><input type="text" [(ngModel)]="item.firstName" class="form-control" /></td>
                    <td><input type="text" [(ngModel)]="item.lastName" class="form-control" /></td>
                    <td><input type="text" [(ngModel)]="item.position" class="form-control" /></td>
                    <td><input type="text" [(ngModel)]="item.startData" class="form-control" /></td>
                    <td><input type="text" [(ngModel)]="item.salary" class="form-control" /></td>
                    <td><input type="text" [(ngModel)]="item.email" class="form-control" /></td>
                    <td>
                      <button _ngcontent-cpj-c276="" type="button" class="btn btn-sm btn-primary" (click)="item.editable = false ; add(item)">
                        <!-- update -->
                        <span _ngcontent-cpj-c276="" class="fe fe-check-circle"></span>
                      </button>
                      <button _ngcontent-ljd-c276="" type="button" class="btn mx-2 btn-sm btn-danger" (click)="item.editable = false">
                        <!-- cancel -->
                        <span _ngcontent-ljd-c276="" class="fe fe-x-circle"></span>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            }
          </div>
        }

        <div class="table-responsive">
          <table class="table table-bordered border text-nowrap mb-0" id="new-edit">
            <thead>
              <tr>
                <th>First name</th>
                <th>Last name</th>
                <th>Position</th>
                <th>Start date</th>
                <th>Salary</th>
                <th>E-mail</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              @for (item of user1; track item) {
                <tr>
                  <td>
                    @if (item.editable) {
                      <div>
                        <input type="text" [(ngModel)]="item.firstName" class="form-control" />
                      </div>
                    }
                    @if (!item.editable) {
                      <div>
                        {{ item.firstName }}
                      </div>
                    }
                  </td>
                  <td>
                    @if (item.editable) {
                      <div>
                        <input type="text" [(ngModel)]="item.lastName" class="form-control" />
                      </div>
                    }
                    @if (!item.editable) {
                      <div>
                        {{ item.lastName }}
                      </div>
                    }
                  </td>
                  <td>
                    @if (item.editable) {
                      <div>
                        <input type="text" [(ngModel)]="item.position" class="form-control" />
                      </div>
                    }
                    @if (!item.editable) {
                      <div>
                        {{ item.position }}
                      </div>
                    }
                  </td>
                  <td>
                    @if (item.editable) {
                      <div>
                        <input type="text" [(ngModel)]="item.startData" class="form-control" />
                      </div>
                    }
                    @if (!item.editable) {
                      <div>
                        {{ item.startData }}
                      </div>
                    }
                  </td>
                  <td>
                    @if (item.editable) {
                      <div>
                        <input type="text" [(ngModel)]="item.salary" class="form-control" />
                      </div>
                    }
                    @if (!item.editable) {
                      <div>
                        {{ item.salary }}
                      </div>
                    }
                  </td>
                  <td>
                    @if (item.editable) {
                      <div>
                        <input type="text" [(ngModel)]="item.email" class="form-control" />
                      </div>
                    }
                    @if (!item.editable) {
                      <div>
                        {{ item.email }}
                      </div>
                    }
                  </td>
                  <td>
                    @if (item.editable) {
                      <button (click)="item.editable = false; update1(item)" type="button"
                        class="btn btn-sm btn-primary">
                        <span class="fe fe-check-circle"> </span>
                        <!-- update -->
                      </button>
                    }
                    @if (!item.editable) {
                      <button type="button" class="btn btn-sm btn-primary" (click)="edit1(item)">
                        <span class="fe fe-edit"> </span>
                        <!-- Edit -->
                      </button>
                    }
                    @if (item.editable) {
                      <button (click)="item.editable = false" type="button"
                        class="btn mx-2 btn-sm btn-danger">
                        <span class="fe fe-x-circle"> </span>
                        <!-- cancel -->
                      </button>
                    }
                    @if (!item.editable) {
                      <button id="bDel" type="button" class="btn mx-3 btn-sm btn-danger"
                        (click)="trash1(item.id)">
                        <span class="fe fe-trash-2"> </span>
                        <!-- trash -->
                      </button>
                    }
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- End Row -->

<!-- Row -->
<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-header">
        <h3 class="card-title">Removed action label, and only some columns are editable</h3>
      </div>
      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-bordered border text-nowrap mb-0" id="removecolumns-edit">
            <thead>
              <tr>
                <th>First name</th>
                <th>Last name</th>
                <th>Position</th>
                <th>Start date</th>
                <th>Salary</th>
                <th>E-mail</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              @for (item of user2; track item) {
                <tr>
                  <td>
                    {{ item.firstName }}
                  </td>
                  <td>
                    @if (item.editable) {
                      <div>
                        <input type="text" [(ngModel)]="item.lastName" class="form-control" />
                      </div>
                    }
                    @if (!item.editable) {
                      <div>
                        {{ item.lastName }}
                      </div>
                    }
                  </td>
                  <td>
                    @if (item.editable) {
                      <div>
                        <input type="text" [(ngModel)]="item.position" class="form-control" />
                      </div>
                    }
                    @if (!item.editable) {
                      <div>
                        {{ item.position }}
                      </div>
                    }
                  </td>
                  <td>
                    {{ item.startData }}
                  </td>
                  <td>
                    {{ item.salary }}
                  </td>
                  <td>
                    {{ item.email }}
                  </td>
                  <td>
                    @if (item.editable) {
                      <button (click)="item.editable = false; update2(item)" type="button"
                        class="btn btn-sm btn-primary">
                        <span class="fe fe-check-circle"> </span>
                        <!-- update -->
                      </button>
                    }
                    @if (!item.editable) {
                      <button type="button" class="btn btn-sm btn-primary" (click)="edit2(item)">
                        <span class="fe fe-edit"> </span>
                        <!-- Edit -->
                      </button>
                    }
                    @if (item.editable) {
                      <button (click)="item.editable = false" type="button"
                        class="btn mx-2 btn-sm btn-danger">
                        <span class="fe fe-x-circle"> </span>
                        <!-- cancel -->
                      </button>
                    }
                    @if (!item.editable) {
                      <button id="bDel" type="button" class="btn mx-3 btn-sm btn-danger"
                        (click)="trash2(item.id)">
                        <span class="fe fe-trash-2"> </span>
                        <!-- trash -->
                      </button>
                    }
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- End Row -->